import React from 'react';

import { IconProps } from './types';

export const ProducerIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    fill="#909090"
    ref={forwardedRef}
    {...props}
  >
    <g>
      <g>
        <g>
          <path
            d="M143.891,239.572c53.747,0,97.472-43.725,97.473-97.472c0-53.747-43.727-97.472-97.473-97.472
				S46.419,88.353,46.419,142.1S90.144,239.572,143.891,239.572z"
          />
          <path
            d="M368.109,239.572c53.747,0,97.473-43.725,97.472-97.472c0-53.747-43.725-97.472-97.472-97.472
				c-53.748,0-97.473,43.725-97.473,97.472S314.363,239.572,368.109,239.572z"
          />
          <path
            d="M143.893,256.631C64.55,256.631,0,321.176,0,400.513v48.799c0,9.974,8.086,18.06,18.06,18.06h251.654
				c9.974,0,18.06-8.086,18.06-18.06v-48.799C287.774,321.998,224.505,256.631,143.893,256.631z"
          />
          <path
            d="M277.24,288.833c-2.528,2.072-2.881,5.8-0.865,8.373c41.185,52.534,35.478,103.328,35.478,152.106
				c0,3.649-0.467,7.192-1.345,10.57c-0.986,3.796,1.906,7.49,5.827,7.49H493.94c9.974,0,18.06-8.086,18.06-18.06v-48.799
				C512,278.181,369.275,213.415,277.24,288.833z"
          />
        </g>
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
));
ProducerIcon.displayName = 'ProducerIcon';

export default ProducerIcon;
